import { Grid, styled } from "@mui/material";
import { useSelector } from "react-redux";
import { MdDelete } from "react-icons/md";
import { SwalFunction } from "../../../../components/commonFunctions/SwalFunction";
import { useParams } from "react-router-dom";
import { axiosFunction } from "../../../../components/commonFunctions/axiosFunction"
import { v2ReactURL } from "../../../../utils/constant";
import { DateFormat } from "../../../../utils/DateFormat";
import { convertToSelectedTimeZoneIntoDate } from "../../../../utils/timeZoneUtil";

const TitleStyle = styled(Grid)({
  background: " #EBEDF3",
  // textTransform: "capitalize",
  padding: "5px 10px",
  fontSize: "13px",
  fontWeight: 500,
  color: "#131313",
});
const DescriptionStyle = styled(Grid)({
  // textTransform: "capitalize",
  padding: "5px 10px",
  fontSize: "13px",
  fontWeight: 500,
  color: "#131313",
});

interface GeneralDetailsDataProps {
  contactType: string;
  fetchContactDetails: () => void;
  imgLocationShow: boolean;
  setImgLocationShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const GeneralDetailsData = ({ contactType ,imgLocationShow,setImgLocationShow}: GeneralDetailsDataProps) => {
  const contactGeneralDetails = useSelector(
    (state:any) => state.contactGeneralDetails
  );
   const sessionList = useSelector((state: any) => state.sessionData.sessionScope);
  // const taxtype = sessionList?.governmentTaxType || "gst";
  const taxtype = !contactGeneralDetails?.ContactDetails?.vatNo?.trim() ? "gst" : "vat";
const decimalPoints = sessionList?.decimalPoint || 2;
  const params = useParams();

  const imgLocation = contactGeneralDetails?.ContactDetails?.imgLocation;

  const firstName = contactGeneralDetails?.ContactDetails?.firstName || "";
  const lastName = contactGeneralDetails?.ContactDetails?.lastName || "";
  const name = `${firstName} ${lastName}` || "-";

  const numberConcat = (prefix:string, number:string) => {
    // console.log("contactGeneralDetails?.ContactDetails?.[prefix]", contactGeneralDetails?.ContactDetails?.[prefix]);
    const countryDialCodePrefix =
      contactGeneralDetails?.ContactDetails?.[prefix] === 0 ? "91" : contactGeneralDetails?.ContactDetails?.[prefix];
    const mobNo = contactGeneralDetails?.ContactDetails?.[number];

    if ((countryDialCodePrefix != null || countryDialCodePrefix != undefined) && mobNo) {
      return `+${countryDialCodePrefix}-${mobNo}`;
    } else {
      return "N/A"; // Return empty string if either prefix or mobNo is undefined
    }
  };

  // console.log("imgLocationShow",imgLocationShow)
  const handleDeleteImage = async () => {
    const result = await SwalFunction(
      "Are You Sure?",
      "You Won't Be Able To Revert This!",
      "Yes, Delete It!",
      { icon: "warning" }
    );

    if (result.isConfirmed) {
      const response = await axiosFunction(
        `${v2ReactURL}/contact/${contactType}/delete/file/${params.contactId}`,
        "DELETE"
      );

      if (response.data) {
        // window.location.reload();
        setImgLocationShow(false);
        // fetchContactDetails()
      }
    }
  };

  const handleDownloadFile = async () => {
    const res = await axiosFunction(
      `${v2ReactURL}/contact/${contactType}/download/${params.contactId}`,
      "GET",
      "",
      false,
      "blob"
    );

    let fileType = "file";
    if (res.headers["content-type"] === "image/png") {
      fileType = `${imgLocation}`;
    } else if (res.headers["content-type"] === "image/jpeg") {
      fileType = `${imgLocation}`;
    } else if (res.headers["content-type"] === "application/pdf") {
      fileType = `${imgLocation}`;
    } else if (res.headers["content-type"] === "image/jpg") {
      fileType = `${imgLocation}`;
    }

    // return;
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;

    // Set filename based on file type
    link.setAttribute("download", fileType);

    // Trigger download
    document.body.appendChild(link);
    link.click();
  };
 const timeZone = useSelector((state: any) => state.sessionData.sessionScope.timeZone || "Asia/Kolkata");
  return (
    <div style={{ margin: "10px", marginBottom: "100px" }}>
      <Grid container item lg={12} spacing={2}>
        {contactGeneralDetails?.ContactDetails?.active == 1 && (
          <div className="col-md-12 mt-3 ml-2">
            <span
              style={{ borderRadius: "5px", fontSize: "14px", fontWeight: 500 }}
              className="badge badge-lg badge-danger"
            >
              Deactive
            </span>
          </div>
        )}
        <Grid item lg={4}>
          <Grid
            container
            item
            lg={12}
            style={{ border: "1px solid #EBEDF3", marginBottom: "10px" }}
          >
            <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
              Since
            </TitleStyle>
            <DescriptionStyle item lg={8} xs={7}>
              {convertToSelectedTimeZoneIntoDate(contactGeneralDetails?.createdOn, timeZone)}
            </DescriptionStyle>
            <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
              Name
            </TitleStyle>
            <DescriptionStyle item lg={8} xs={7}>
              {name}
            </DescriptionStyle>
            <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
              Company Name
            </TitleStyle>
            <DescriptionStyle item lg={8} xs={7}>
              {contactGeneralDetails?.ContactDetails?.companyName ||
                "No Company Name is provided"}
            </DescriptionStyle>
            <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
              Type
            </TitleStyle>
            <DescriptionStyle item lg={8} xs={7}>
              {contactGeneralDetails?.ContactDetails?.contactType || "N/A"}
            </DescriptionStyle>

            {contactType !== "transport" && (
              <>
                <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
                  Code
                </TitleStyle>
                <DescriptionStyle item lg={8} xs={7}>
                  {contactGeneralDetails?.ContactDetails?.code || "N/A"}
                </DescriptionStyle>
              </>
            )}

            <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
              Contact No.
            </TitleStyle>
            <DescriptionStyle item lg={8} xs={7}>
              {contactGeneralDetails?.ContactDetails?.mobNo ? (
                <a href={`tel:${contactGeneralDetails?.ContactDetails?.mobNo}`}>
                  {numberConcat("countryDialCodePrefix", "mobNo")}
                </a>
              ) : (
                numberConcat("countryDialCodePrefix", "mobNo")
              )}
            </DescriptionStyle>
            {contactType !== "transport" && (
              <>
                <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
                  Whats app No.
                </TitleStyle>
                <DescriptionStyle item lg={8} xs={7}>
                  {numberConcat("countryDialCodePrefixWhatsapp", "whatsappNo")}
                </DescriptionStyle>
              </>
            )}
            <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
              Email
            </TitleStyle>
            <DescriptionStyle item lg={8} xs={7}>
              {contactGeneralDetails?.ContactDetails?.email ||
                "Email is Not Provided"}
            </DescriptionStyle>

            <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
              PAN No.
            </TitleStyle>
            <DescriptionStyle item lg={8} xs={7}>
              {contactGeneralDetails?.ContactDetails?.pan || "N/A"}
            </DescriptionStyle>

            {contactType === "suppliers" && (
              <>
                <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
                  TAN No.
                </TitleStyle>
                <DescriptionStyle item lg={8} xs={7}>
                  {contactGeneralDetails?.ContactDetails?.tanNo || "N/A"}
                </DescriptionStyle>
              </>
            )}

            {(contactType === "customers" && contactGeneralDetails?.membership === 1) && (
              <>
                <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
                  Membership
                </TitleStyle>
                <DescriptionStyle item lg={8} xs={7}>
                  {contactGeneralDetails?.ContactDetails?.membershipName || "-"}
                </DescriptionStyle>
              </>
            )}
           {(contactType === "customers" && contactGeneralDetails?.allowb2b === 1) && (
              <>
                <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
                  Customer Category
                </TitleStyle>
                <DescriptionStyle item lg={8} xs={7}>
                  {contactGeneralDetails?.ContactDetails?.customerCategoryName || "-"}
                </DescriptionStyle>
              </>
            )}



            <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
              {contactGeneralDetails?.outstanding >= 0 ? "Due " : "Advance "}
              Payment
            </TitleStyle>
            <DescriptionStyle
              style={{
                color:
                  contactGeneralDetails?.outstanding >= 0 ? "red" : "#34bfa3",
              }}
              item
              lg={8}
              xs={7}
            >
              {contactGeneralDetails?.outstanding >= 0
                ? contactGeneralDetails?.outstanding?.toFixed(decimalPoints)
                :Number(contactGeneralDetails?.outstanding?.toString()?.split("-")[1])?.toFixed(decimalPoints) || (0)?.toFixed(decimalPoints)}
            </DescriptionStyle>

            {contactType !== "customers" && (
              <>
                <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
                  Payment Terms
                </TitleStyle>
                <DescriptionStyle item lg={8} xs={7}>
                  {contactGeneralDetails?.ContactDetails?.paymentTermName || "N/A"}
                </DescriptionStyle>
                <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
                  Payment Mode
                </TitleStyle>
                <DescriptionStyle item lg={8} xs={7}>
                  {contactGeneralDetails?.ContactDetails?.paymentName || "N/A"}
                </DescriptionStyle>
              </>
            )}
          </Grid>
        </Grid>
        {contactType === "suppliers" && (
          <Grid item lg={4}>
            <Grid
              container
              item
              lg={12}
              style={{ border: "1px solid #EBEDF3", marginBottom: "10px" }}
            >
              <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
                Bank Name
              </TitleStyle>
              <DescriptionStyle item lg={8} xs={7}>
                {contactGeneralDetails?.ContactDetails?.bankName || "N/A"}
              </DescriptionStyle>
              <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
                Branch Name
              </TitleStyle>
              <DescriptionStyle item lg={8} xs={7}>
                {contactGeneralDetails?.ContactDetails?.bankBranch || "N/A"}
              </DescriptionStyle>
              <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
                Account No.
              </TitleStyle>
              <DescriptionStyle item lg={8} xs={7}>
                {contactGeneralDetails?.ContactDetails?.bankAcNo || "N/A"}
              </DescriptionStyle>
              <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
                Bank IFSC Code
              </TitleStyle>
              <DescriptionStyle item lg={8} xs={7}>
                {contactGeneralDetails?.ContactDetails?.bankIfsc || "N/A"}
              </DescriptionStyle>
            </Grid>
          </Grid>
        )}
        <Grid item lg={4}>
          <Grid
            container
            item
            lg={12}
            style={{ border: "1px solid #EBEDF3", marginBottom: "10px" }}
          >
            <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
              Telephone No.
            </TitleStyle>
            <DescriptionStyle item lg={8} xs={7}>
              {contactGeneralDetails?.ContactDetails?.telephone || "N/A"}
            </DescriptionStyle>
            <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
              Date Of Birth
            </TitleStyle>
            <DescriptionStyle item lg={8} xs={7}>
              {DateFormat(
                contactGeneralDetails?.ContactDetails?.dateOfBirth
              ) || "N/A"}
            </DescriptionStyle>
            <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
              Anniversary Date
            </TitleStyle>
            <DescriptionStyle item lg={8} xs={7}>
              {DateFormat(
                contactGeneralDetails?.ContactDetails?.anniversaryDate
              ) || "N/A"}
            </DescriptionStyle>
            {taxtype == "vat" && (
              <>
                {" "}
                <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
                  VAT No.
                </TitleStyle>
                <DescriptionStyle item lg={8} xs={7}>
                  {
                    contactGeneralDetails?.ContactDetails?.vatNo
                  || "N/A"}
                </DescriptionStyle>
              </>
            )}
            <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
              Remarks
            </TitleStyle>
            <DescriptionStyle item lg={8} xs={7}>
              {contactGeneralDetails?.ContactDetails?.remark || "N/A"}
            </DescriptionStyle>
            <TitleStyle style={{fontWeight : 'bold'}} item lg={4} xs={5}>
              Account Group Name
            </TitleStyle>
            <DescriptionStyle item lg={8} xs={7}>
              {contactGeneralDetails?.ContactDetails?.accountGroupName || "N/A"}
            </DescriptionStyle>
          </Grid>
        </Grid>
        {contactType === "transport" && (
          <Grid item lg={4}>
            <Grid
              container
              item
              lg={12}
              style={{ border: "1px solid #EBEDF3", marginBottom: "10px" }}
            >
              <TitleStyle style={{fontWeight : 'bold'}} item lg={4}>
                Transporter Id
              </TitleStyle>
              <DescriptionStyle item lg={8}>
                {contactGeneralDetails?.ContactDetails?.transporterId || "N/A"}
              </DescriptionStyle>
            </Grid>
          </Grid>
        )}
      </Grid>
      {imgLocationShow && (
        <div style={{ display: "flex", alignItems: "center" }} className="p-3">
          <span style={{ fontWeight: 600 }}>Attachment: </span>&ensp;
          {/* <a
            download
            href={imgLocation}
            style={{ cursor: "pointer", color: "#36a3f7" }}
          >
            Download File
          </a> */}
          <span
            onClick={handleDownloadFile}
            style={{ cursor: "pointer", color: "#36a3f7" }}
          >
            Download File
          </span>
          <button
            style={{
              color: "#f4516c",
              border: "none",
              backgroundColor: "transparent",
            }}
            onClick={handleDeleteImage}
          >
            <MdDelete size={18} />
          </button>
        </div>
      )}
    </div>
  );
};

export default GeneralDetailsData;
